import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { DragObjetType } from '../types';
import { DragControls } from 'three/examples/jsm/controls/DragControls';
import BasicObject from '../meshes/BasicObject';

interface Props {
  camera: THREE.Camera;
  renderer: THREE.WebGLRenderer;
  orbitControls: OrbitControls;
}
export const createDragControlsObject = ({
  camera,
  renderer,
  orbitControls,
}: Props): DragObjetType => {
  const objectsMoving: Array<THREE.Mesh> = [];

  const DRAG: DragObjetType = {
    orbitControls,
    dragControls: new DragControls(objectsMoving, camera, renderer.domElement),

    activateControls() {
      if (this.dragControls) {
        this.dragControls.addEventListener('dragstart', dragStartMoveControls);
        this.dragControls.addEventListener('drag', dragMoveControls);
        this.dragControls.addEventListener('dragend', dragEndMoveControls);
        this.dragControls.addEventListener('hoveron', hoverOnControls);
        this.dragControls.addEventListener('hoveroff', hoverOffControls);
      }
    },
    deactivateControls() {
      if (this.dragControls) {
        this.dragControls.removeEventListener('dragstart', dragStartMoveControls);
        this.dragControls.removeEventListener('drag', dragMoveControls);
        this.dragControls.removeEventListener('dragend', dragEndMoveControls);
        this.dragControls.removeEventListener('hoveron', hoverOnControls);
        this.dragControls.removeEventListener('hoveroff', hoverOffControls);

        this.dragControls.deactivate();
        this.dragControls.dispose();
      }
    },
    addObjectMove(object: THREE.Mesh) {
      objectsMoving.push(object);
    },
    removeObjectMove(uuidObj: string) {
      const index = objectsMoving.findIndex(item => item.uuid === uuidObj);
      if (index !== -1) {
        objectsMoving.splice(index, 1);
      }
      // objectsMoving = objectsMoving.filter(item => item.uuid !== uuidObj);
    },
  };

  return DRAG;

  function dragStartMoveControls(event: THREE.Event) {
    if (DRAG.orbitControls) {
      DRAG.orbitControls.enabled = false;
    }
    const obj = event.object as BasicObject;
    // if (obj.type === 'text_point') {
    //   if (DRAG.dragControls) {
    //     DRAG.dragControls.enabled = false;
    //   }
    // }
    obj.dragStart();
  }
  function dragMoveControls(event: THREE.Event) {
    const obj = event.object as BasicObject;
    obj.drag();
  }
  function dragEndMoveControls(event: THREE.Event) {
    if (DRAG.orbitControls) {
      DRAG.orbitControls.enabled = true;
    }
    const obj = event.object as BasicObject;
    obj.dragEnd();
    if (DRAG.dragControls) {
      DRAG.dragControls.enabled = true;
    }
  }
  function hoverOnControls(event: THREE.Event) {
    const obj = event.object as BasicObject;
    obj.hoverOn();
  }
  function hoverOffControls(event: THREE.Event) {
    const obj = event.object as BasicObject;
    obj.hoverOff();
  }
};
